export default __webpack_public_path__ + "static/media/ControlStock.a982a097.png";